import {CompetitorSquadPageRouteMetaDataModel} from "./competitor.squad-page.route.meta-data.model";
import {PAGES} from "../../../../../core/consts";
import {CompetitorPageRouteConfig} from "../../../models/competitor.page-route.config";

export class CompetitorSquadPageRouteConfig extends CompetitorPageRouteConfig {
  static injectables = [];

  constructor() {
    super({
      name: PAGES.COMPETITOR.squad,
      path: 'squad',
      componentImport: () => import("../components/competitor.squad-page" /* webpackChunkName: "competitor.squad-page" */),
      metadataType: CompetitorSquadPageRouteMetaDataModel
    });
  }
}